export default "__VITE_ASSET__b2bbde54__"